const GUIDE_ID = 'erp-column-resize-guide';

const ensureGuideElement = () => {
  if (typeof document === 'undefined') return null;

  let guide = document.getElementById(GUIDE_ID);
  if (guide) return guide;

  guide = document.createElement('div');
  guide.id = GUIDE_ID;
  guide.setAttribute('aria-hidden', 'true');
  Object.assign(guide.style, {
    position: 'fixed',
    top: '0',
    bottom: '0',
    width: '2px',
    background: 'linear-gradient(180deg, rgba(59,130,246,0.18) 0%, rgba(59,130,246,0.95) 16%, rgba(59,130,246,0.95) 84%, rgba(59,130,246,0.18) 100%)',
    boxShadow: '0 0 0 1px rgba(191,219,254,0.75), 0 0 18px rgba(59,130,246,0.22)',
    pointerEvents: 'none',
    zIndex: '9999',
    opacity: '0',
    transform: 'translateX(-9999px)',
    transition: 'opacity 120ms ease-out',
  });
  document.body.appendChild(guide);
  return guide;
};

export const showResizeGuide = (x) => {
  if (typeof document === 'undefined') return;
  const guide = ensureGuideElement();
  if (!guide) return;
  guide.style.opacity = '1';
  guide.style.transform = `translateX(${Math.round(x)}px)`;
  document.body.style.cursor = 'col-resize';
  document.body.style.userSelect = 'none';
};

export const hideResizeGuide = () => {
  if (typeof document === 'undefined') return;
  const guide = document.getElementById(GUIDE_ID);
  if (guide) {
    guide.style.opacity = '0';
    guide.style.transform = 'translateX(-9999px)';
  }
  document.body.style.cursor = '';
  document.body.style.userSelect = '';
};
